import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = ["href", "onClick", "target", "rel"]

import { ref, watch } from "vue";
import {
	LMap,
	LTileLayer,
	LMarker,
	LPopup,
	LPolyline,
} from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";



export default /*#__PURE__*/_defineComponent({
  __name: 'MapComponent',
  props: {
	locations: Array,
	color: { type: String, default: "blue" },
},
  setup(__props) {

const props = __props;



const paddingValue = 20;

const mapRef = ref(null);

const onMapReady = (mapInstance) => {
	if (mapInstance && props.locations.length) {
		const bounds = L.latLngBounds(
			props.locations.map((loc) => [loc.lat, loc.lon])
		);
		mapInstance.fitBounds(bounds, {
			padding: [paddingValue, paddingValue],
		});
	}
};

watch(
	() => props.locations,
	() => {
		if (mapRef.value && props.locations.length) {
			const bounds = L.latLngBounds(
				props.locations.map((loc) => [loc.lat, loc.lon])
			);
			mapRef.value.leafletObject.fitBounds(bounds, {
				padding: [paddingValue, paddingValue],
			});
		}
	}
);

const customIcon = new L.Icon({
	iconUrl:
		"https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|ff8a65",
	iconSize: [30, 42],
	iconAnchor: [15, 42],
	popupAnchor: [0, -42],
});

const scrollToSection = (id: string) => {
	const section = document.querySelector(id);
	if (section) {
		section.scrollIntoView({ behavior: "smooth" });
	}
};

const handleLinkClick = (link: string) => {
	if (link.startsWith("#")) {
		scrollToSection(link);
	} else {
		// Ensure `window` is available before calling `open`
		if (typeof window !== "undefined") {
			window.open(link, "_blank", "noopener,noreferrer");
		} else {
			console.error("Window object is not available");
		}
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LMap), {
    ref_key: "mapRef",
    ref: mapRef,
    onReady: onMapReady,
    style: {"height":"700px","width":"100%","border-radius":"12px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(LTileLayer), {
        url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
        attribution: "© <a href='https://www.openstreetmap.org/copyright'>OSM</a> © <a href='https://carto.com/'>CARTO</a>"
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locations, (location) => {
        return (_openBlock(), _createBlock(_unref(LMarker), {
          key: location.id,
          "lat-lng": [location.lat, location.lon]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LPopup), null, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(location.id) + ". " + _toDisplayString(location.name), 1),
                _hoisted_1,
                (location.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: location.link,
                      onClick: _withModifiers(($event: any) => (handleLinkClick(location.link)), ["prevent"]),
                      target: location.link.startsWith('#') ? '_self' : '_blank',
                      rel: location.link.startsWith('#') ? '' : 'nofollow'
                    }, "Mer info", 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["lat-lng"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locations.slice(0, __props.locations.length - 1), (location, index) => {
        return (_openBlock(), _createBlock(_unref(LPolyline), {
          key: 'line-' + index,
          "lat-lngs": [
				[location.lat, location.lon],
				[__props.locations[index + 1].lat, __props.locations[index + 1].lon],
			],
          color: __props.color,
          weight: "2"
        }, null, 8, ["lat-lngs", "color"]))
      }), 128)),
      (__props.locations.length > 1)
        ? (_openBlock(), _createBlock(_unref(LPolyline), {
            key: 0,
            "lat-lngs": [
				[
					__props.locations[__props.locations.length - 1].lat,
					__props.locations[__props.locations.length - 1].lon,
				],
				[__props.locations[0].lat, __props.locations[0].lon],
			],
            color: __props.color,
            weight: "2"
          }, null, 8, ["lat-lngs", "color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})